import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { InfoModalComponent } from '../modals/info-modal/info-modal.component';
import { AuthService } from '@app/api/api-services/auth.service';
import { RouteHelperService } from './route-helper.service';
import { ProgramType } from '../enums/program-type.enum';
import { TokenStorageService } from './token-storage.service';

@Injectable()
export class RedirectService {
  constructor(
    private readonly tokenStorageService: TokenStorageService,
    private readonly bsModalService: BsModalService,
    private readonly authService: AuthService,
    private readonly routeHelper: RouteHelperService
  ) {
    this.authService.programChange.subscribe(this.redirectToDefault.bind(this));
  }

  public shadowInit(): void {}

  public handleLogin(redirectUrl: string | null = null): void {
    const userInfo = this.tokenStorageService.userInfo;

    if (redirectUrl !== null) {
      this.routeHelper.navigateByUrl(redirectUrl);
    } else if (userInfo.IsSysAdmin) {
      this.routeHelper.sites();
    } else {
      this.redirectToDefault();
    }
  }

  public redirectToDefault(): void {
    if (!this.authService.isAuthenticated()) {
      return;
    }

    const userInfo = this.tokenStorageService.userInfo;
    const availablePrograms = userInfo.AvailablePrograms;

    if (userInfo.CurrentProgramId && availablePrograms.some((x) => x.Id === userInfo.CurrentProgramId)) {
      if (userInfo.IsTrainee) {
        this.routeHelper.dashboard(userInfo.CurrentProgramRoleId, true);
      } else {
        if (userInfo.CurrentProgram.Type === ProgramType.PerformanceEvaluation) {
          this.routeHelper.performanceDashboard();
        } else {
          this.routeHelper.programUsersList(true);
        }
      }
    } else {
      if (availablePrograms && availablePrograms.length) {
        const firstAvailable = availablePrograms[0];
        this.authService.changeCurrent(userInfo.CurrentSiteId, firstAvailable.Id).subscribe(() => {});
      } else {
        if (!userInfo.IsSysAdmin && !userInfo.IsSiteAdmin && !userInfo.IsObserver) {
          if (userInfo.CurrentSite.TrainingCoursesEnabled) {
            //this.routeHelper.trainingCoursesDashboard(); - Training Courses disabled
            this.openWarningModal();
            this.routeHelper.blank();
          } else {
            this.openWarningModal();
            this.routeHelper.blank();
          }
        } else {
          this.routeHelper.programs();
        }
      }
    }
  }

  private openWarningModal(): void {
    const initialState = {
      title: 'Warning!',
      text: 'This user is not assigned to any active programs. Please contact your PowerReady site administrator to gain access.'
    };

    this.bsModalService.show(InfoModalComponent, {
      initialState,
      backdrop: 'static'
    });
  }
}
